// @ts-nocheck

import memoize from 'memoize-state';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import { onCheckBox } from '../../actions/basket';
import GridsGrid from '../../components/grid/GridsGrid';
import { editableSystemGridSelector } from '../../selectors/grid';

const legacySelector = memoize(editableSystemGridSelector);

type GridsSystemGridContainerProps = {
  className?: string;
  poolId: number;
  isReadOnly: boolean;
  selection: string;
  selectionIndex: number;
};

const GridsSystemGridContainer = ({
  poolId,
  isReadOnly,
  selectionIndex,
  ...ownProps
}: GridsSystemGridContainerProps) => {
  const dispatch = useDispatch();

  const selectedProps = useSelector((state) => legacySelector(state, { poolId, isReadOnly }));

  const onCheckbox = useCallback(
    (matchIndex, typeCheck) => {
      dispatch(onCheckBox(matchIndex, typeCheck, selectionIndex));
    },
    [selectionIndex, dispatch],
  );

  const otherProps = useMemo(
    () => ({
      onCheckBox: isReadOnly ? undefined : onCheckbox,
    }),
    [isReadOnly, onCheckbox],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <GridsGrid {...enhancedProps} />;
};

export default GridsSystemGridContainer;
